(() => {
  if (window.VianelliCollectionMediaIntent) return;
  const requests = new WeakMap();
  const activate = link => {
    if (!document.body?.classList.contains('vianelli-collections') || !link?.isConnected) return false;
    const image = link.querySelector('img[data-vianelli-src]');
    if (!image || requests.has(image)) return false;
    const state = { status: 'loading' };
    requests.set(image, state);
    const fail = () => {
      state.status = 'error';
      link.dataset.vianelliHoverState = 'error';
      // The pending class deliberately keeps the primary image and native link.
    };
    const ready = async () => {
      if (state.status !== 'loading' || !image.complete || image.naturalWidth <= 0) return;
      state.status = 'decoding';
      try {
        if (typeof image.decode === 'function') await image.decode();
        // A filtered-out grid may be cached while decoding. Completing its local
        // image state off-document is safe and lets a restored card hover again.
        if (image.naturalWidth <= 0) { fail(); return; }
        state.status = 'ready';
        link.dataset.vianelliHoverState = 'ready';
        image.removeAttribute('data-vianelli-src');
        image.removeAttribute('data-vianelli-srcset');
        image.removeAttribute('data-vianelli-hover');
        link.classList.remove('vianelli-hover-pending');
      } catch { fail(); }
    };
    image.addEventListener('load', ready, { once: true });
    image.addEventListener('error', fail, { once: true });
    image.loading = 'eager';
    const srcset = image.getAttribute('data-vianelli-srcset');
    if (srcset) image.setAttribute('srcset', srcset);
    image.setAttribute('src', image.getAttribute('data-vianelli-src'));
    if (image.complete && image.naturalWidth > 0) ready();
    return true;
  };
  const intent = event => {
    const link = event.target?.closest?.('#product-grid > li[data-vianelli-server-rendered] .card__media a.vianelli-hover-pending');
    if (link) activate(link);
  };
  // Delegation also covers freshly filtered, paginated and restored cards.
  // These listeners neither cancel input nor postpone native product navigation.
  for (const type of ['pointerover', 'focusin', 'pointerdown', 'touchstart']) {
    document.addEventListener(type, intent, { capture: true, passive: true });
  }
  window.VianelliCollectionMediaIntent = { activate };
  // The deferred asset may execute after the first pointer/focus intent. Activate
  // only those current targets once; no image scan, observer or eager hydration.
  const selector = '#product-grid > li[data-vianelli-server-rendered] .card__media a.vianelli-hover-pending';
  const focused = document.activeElement?.closest?.(selector);
  if (focused) activate(focused);
  const hovered = document.querySelector(selector + ':hover');
  if (hovered) activate(hovered);
})();
